<template>
  <div class="content_earnings">
    <!--    搜索框-->
    <div class="search_box">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-select v-model="formInline.station" placeholder="充电站" clearable>
            <el-option label="停车场充电站1" value="station1"></el-option>
            <el-option label="停车场充电站2" value="station2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
              v-model="formInline.time"
              type="datetimerange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" class="btn">查询</el-button>
          <el-button type="primary" @click="upLoad" class="btn">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--    总交易-->
    <div class="total">
      <div class="total_item" v-for="item in list" :key="item.id">
        <div class="img">
          <img :src="item.img" alt="">
        </div>
        <div class="info">
          <div>{{ item.label }}</div>
          <div>
            {{ item.value }}
            <span style="font-size: 20rem; ">{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="charts" style="overflow: visible">
      <div>总收益变化曲线图</div>
      <Charts id="statusChart" :option="optionStatus" height="48vh"></Charts>
    </div>
  </div>
</template>

<script>
import countIcon from "../../../assets/img/count_icon.png"
import priceIcon from "../../../assets/img/price_icon.png"
import Charts from '../../../components/common/Charts.vue'
import {getLastOrNextFewDateBy} from "../../../util/DateUtil.js"

export default {
  name: "content_earnings",
  components: {
    Charts
  },
  data() {
    return {
      formInline: {
        station: '',
        time: []
      },
      list: [
        {
          id: 0,
          label: '总交易金额',
          value: 12038.28,
          unit: '￥',
          img: priceIcon
        }, {
          id: 1,
          label: '总交易次数',
          value: 7166,
          unit: '次',
          img: countIcon
        }
      ]
    }
  },
  computed: {
    optionStatus() {
      let xData = getLastOrNextFewDateBy(new Date())
      let dataValue = [10, 20, 23, 34, 45, 45, 45]
      console.log(Math.max(...dataValue))
      return {
        grid: {
          left: "0%",
          right: "6%",
          bottom: "10%",
          top: "10%",
          containLabel: true,
        },
        title: {
          text: '(￥)',
          left: -5,// 距离左边位置
          top: 0,// 距离上面位置
          textStyle: {
            color: '#333',
            fontWeight: 'bold',
            fontSize: 12,
            // fontStyle: 'italic'
          }
        },
        color: ["#5ad8a6", "#5AD8A6"],
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> ￥</b>`;
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: xData,
          axisLabel: {
            fontSize: 12,
            color: "#333",
            fontWeight: 'bold'
          }
        },
        yAxis: {
          max: Math.max(...dataValue) + 100,
          min: 0,
          type: "value",
          nameTextStyle: {
            align: "left",
            padding: [0, 0, 0, 24],
            fontSize: 16,
            color: "#333",
          },
          // splitLine: {
          //   show: true,
          //   lineStyle: {
          //     type: 'dashed',
          //   }
          // },
          axisLabel: {
            fontSize: 12,
            color: "#333",
            fontWeight: 'bold'
          }
        },
        series: [

          {
            data: dataValue,
            type: "line",
            name: "发电功率",
            // smooth: true,
            symbol: 'none',
            itemStyle: {
              color: "#5ad8a6",
            },
            step: 'end',
            markPoint: {
              symbol: 'pin',
              symbolSize: 20,
              data: [
                {type: 'max', name: 'Max'},
                // { type: 'min', name: 'Min' }
              ],
              label: {
                position: 'top',
                fontSize: 14,
                formatter: function (params) {
                  // console.log(params);
                  return `${params.value} ￥`
                }
              }
            },
          },
        ],
      }
    }
  },
  methods: {
    onSubmit() {
      console.log('查询!');
    },

    upLoad() {
      console.log('导出')
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-input__inner {
  height: 42rem;
  font-size: 18rem;
}

::v-deep .el-form-item {
  margin-bottom: 0;
}

.content_earnings {
  font-size: 18rem;

  .search_box {
    margin-bottom: 36rem;

    .btn {
      width: 100rem;
      height: 42rem;
      font-size: 18rem;
      border-radius: 0;
    }
  }

  .total {
    display: flex;
    margin-bottom: 24rem;

    .total_item {
      width: 25vw;
      height: 15vh;
      border: 1rem solid #D9D9D9;
      border-radius: 8rem;
      margin-right: 10rem;
      display: flex;
      align-items: center;
      justify-content: center;

      .img {
        margin-right: 38rem;
      }

      .info {

        & div:nth-child(1) {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #666666;
        }

        & div:nth-child(2) {
          font-size: 36px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #0D94FF;
        }
      }
    }
  }

  .charts {
    height: 48vh;
  }
}
</style>